<template>
  <div class="special-case-step col-lg-10">
    <section class="step-group">
      <h3>{{ $t("tools.special_cases.work_context") }}</h3>
      <div class="step-fields">
        <div v-for="selector in contextSelectors" :key="selector.field" class="editor-field">
          <label>{{ $t(selector.label) }}</label>
          <DxSelectBox
            :value="localData[selector.field]"
            :data-source="selector.options"
            value-expr="uuid"
            display-expr="name"
            :search-enabled="true"
            :show-clear-button="true"
            :disabled="saving"
            @value-changed="setSelection(selector.field, $event.value)"
          />
        </div>
      </div>
    </section>
    <section class="step-group">
      <h3>{{ $t("tools.special_cases.work_assignment") }}</h3>
      <div class="step-fields">
        <div v-for="selector in assignmentSelectors" :key="selector.field" class="editor-field">
          <label>{{ $t(selector.label) }}</label>
          <DxSelectBox
            :value="localData[selector.field]"
            :data-source="selector.options"
            value-expr="uuid"
            display-expr="name"
            :search-enabled="true"
            :show-clear-button="true"
            :disabled="saving"
            @value-changed="setSelection(selector.field, $event.value)"
          />
        </div>
      </div>
    </section>
    <section class="step-group">
      <h3>{{ $t("tools.special_cases.resources") }}</h3>
      <div class="step-fields">
        <div class="editor-field">
          <label>{{ $t("tools.special_cases.equipment") }}</label>
          <DxTagBox
            :value="localData.equipment_uuids"
            :data-source="equipment"
            value-expr="uuid"
            display-expr="name"
            :search-enabled="true"
            :show-selection-controls="true"
            :disabled="saving"
            @value-changed="setSelection('equipment_uuids', $event.value)"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DxSelectBox from "devextreme-vue/select-box";
import DxTagBox from "devextreme-vue/tag-box";

export default {
  name: "SpecialCaseWorkSetupStep",
  components: { DxSelectBox, DxTagBox },
  props: {
    formData: { type: Object, required: true },
    options: { type: Object, required: true },
    mode: { type: String, required: true },
    saving: { type: Boolean, default: false },
  },
  data() {
    return { localData: { ...this.formData, equipment_uuids: [...(this.formData.equipment_uuids || [])] } };
  },
  computed: {
    contextSelectors() {
      return [
        { field: "department_uuid", label: "tools.import_validator.department", options: this.options.departments || [] },
        { field: "season_uuid", label: "common.season", options: this.options.seasons || [] },
      ];
    },
    assignmentSelectors() {
      const selectors = [];
      /*if (this.mode === "assign") {
        selectors.push({ field: "culture_uuid", label: "common.culture", options: this.options.cultures || [] });
      }*/
      selectors.push(
        { field: "work_uuid", label: "common.work_name", options: this.options.works || [] },
        { field: "person_uuid", label: "tools.import_validator.person", options: this.options.persons || [] },
        {
          field: "machine_uuid",
          label: "tools.import_validator.work_machine_name",
          options: (this.options.machines || []).filter((machine) => !machine.equipment),
        },
      );
      return selectors;
    },
    equipment() {
      return (this.options.machines || []).filter((machine) => machine.equipment);
    },
  },
  watch: {
    formData: {
      deep: true,
      handler(value) {
        if (JSON.stringify(this.localData) !== JSON.stringify(value)) {
          this.localData = { ...value, equipment_uuids: [...(value.equipment_uuids || [])] };
        }
      },
    },
    localData: {
      deep: true,
      handler(value) {
        if (JSON.stringify(value) !== JSON.stringify(this.formData)) this.$emit("input", { ...value });
      },
    },
  },
  methods: {
    setSelection(field, value) {
      this.$set(this.localData, field, value);
      if (field === "department_uuid" || field === "season_uuid") {
        this.$set(this.localData, "target_uuids", []);
        this.$set(this.localData, "target_parcels", []);
        this.$set(this.localData, "target_filters", {});
      }
    },
    validate() {
      const requiredFields = [
        ["department_uuid", "tools.import_validator.department"],
        ["season_uuid", "common.season"],
        ["work_uuid", "common.work_name"],
        ["person_uuid", "tools.import_validator.person"],
        ["machine_uuid", "tools.import_validator.work_machine_name"],
      ];
      // if (this.mode === "assign") requiredFields.push(["culture_uuid", "common.culture"]);
      return requiredFields
        .filter(([field]) => !this.localData[field])
        .map(([, label]) => this.$t("tools.special_cases.required", { field: this.$t(label) }));
    },
  },
};
</script>

<style lang="scss" scoped>
.special-case-step {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.step-group {
  padding-bottom: 18px;
  border-bottom: 1px solid #dedede;
}
.step-group h3 {
  margin: 0 0 12px;
  font-size: 17px;
}
.step-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}
.editor-field {
  min-width: 0;
}
.editor-field label {
  display: block;
  margin-bottom: 5px;
}
@media (max-width: 680px) {
  .step-fields {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>